(() => {
  const alpha = new Map([
    ['XXXS', 1], ['3XS', 1], ['XXS', 2], ['2XS', 2], ['XS', 3],
    ['S', 4], ['M', 5], ['L', 6], ['XL', 7], ['XXL', 8], ['2XL', 8],
    ['XXXL', 9], ['3XL', 9], ['XXXXL', 10], ['4XL', 10]
  ]);

  const clean = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, ' ');

  const sizeRank = (value) => {
    const size = clean(value);
    if (alpha.has(size)) return alpha.get(size);

    const numeric = size.replace(',', '.');
    if (/^\d+(?:\.\d+)?(?:\s*[-/]\s*\d+(?:\.\d+)?)?$/.test(numeric)) {
      return 100 + parseFloat(numeric);
    }

    const age = numeric.match(/^(\d+(?:\.\d+)?)(?:\s*[-/]\s*\d+(?:\.\d+)?)?\s*(M|Y|A)$/);
    if (age) {
      const amount = parseFloat(age[1]);
      return 1000 + (age[2] === 'M' ? amount : amount * 12);
    }

    const prefixed = numeric.match(/^(?:EU|EUR|US|UK)\s*(\d+(?:\.\d+)?)$/);
    if (prefixed) return 100 + parseFloat(prefixed[1]);

    return null;
  };

  const sortNodes = (container, nodes, valueOf) => {
    if (nodes.length < 2) return;
    const ranked = nodes.map((node, index) => ({ node, index, rank: sizeRank(valueOf(node)) }));
    if (ranked.some((item) => item.rank === null)) return;

    const sorted = ranked.slice().sort((a, b) => a.rank - b.rank || a.index - b.index);
    const signature = sorted.map((item) => clean(valueOf(item.node))).join('|');
    if (container.dataset.maraisSizeOrder === signature) return;

    sorted.forEach((item) => container.append(item.node));
    container.dataset.maraisSizeOrder = signature;
  };

  const sortCardSizes = (container) => {
    sortNodes(container, [...container.children].filter((node) => node.classList.contains('product-card__size')), (node) => node.textContent);
  };

  const sortAppSizes = (container) => {
    const nodes = [...container.children].filter((node) => node.matches('.mpg-swatch__option'));
    const namedAsSize = nodes.length > 1 && nodes.every((node) => /^(talla|size)$/i.test(node.getAttribute('o-name') || ''));
    if (!namedAsSize) return;
    sortNodes(container, nodes, (node) => node.getAttribute('o-value') || node.textContent);
  };

  const sortNativeSizes = (container) => {
    const labels = [...container.children].filter((node) => node.matches('label.block-swatch'));
    if (labels.length < 2 || labels.some((label) => sizeRank(label.textContent) === null)) return;

    const ranked = labels.map((label, index) => ({ label, input: label.htmlFor ? document.getElementById(label.htmlFor) : null, index, rank: sizeRank(label.textContent) }));
    const sorted = ranked.slice().sort((a, b) => a.rank - b.rank || a.index - b.index);
    const signature = sorted.map((item) => clean(item.label.textContent)).join('|');
    if (container.dataset.maraisSizeOrder === signature) return;

    sorted.forEach(({ input, label }) => {
      if (input && input.parentElement === container) container.append(input);
      container.append(label);
    });
    container.dataset.maraisSizeOrder = signature;
  };

  const sortAll = (root = document) => {
    root.querySelectorAll('.product-card__size-list').forEach(sortCardSizes);
    root.querySelectorAll('.mpg-swatch__nav').forEach(sortAppSizes);
    root.querySelectorAll('.variant-picker__option-values').forEach(sortNativeSizes);
  };

  let frame;
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => sortAll());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  const prepareSizeQuickAdd = (event) => {
    const button = event.target.closest('[data-marais-size-quick-add]');
    if (!button) return;

    const drawerId = button.getAttribute('aria-controls');
    const drawer = drawerId ? document.getElementById(drawerId) : null;
    const handle = button.dataset.quickBuyHandle;
    if (!drawer || !handle) return;

    drawer.setAttribute('handle', handle);
    drawer.removeAttribute('loaded');
    drawer.removeAttribute('data-loaded');
    drawer.replaceChildren();

    button.closest('.product-card__size-list')?.querySelectorAll('.product-card__size.is-selected').forEach((node) => {
      node.classList.remove('is-selected');
      node.removeAttribute('aria-pressed');
    });
    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');
  };

  document.addEventListener('click', prepareSizeQuickAdd, true);
  document.addEventListener('shopify:section:load', schedule);
})();